import { jsx as _jsx } from "react/jsx-runtime";
import { useWalletDetails } from "@sundae/wallet-react";
import { lazy } from "react";
import ConnectWalletButton from "../ConnectWalletButton/index.js";
const LazyWalletDetailsPopover = lazy(() => import("../WalletDetailsPopover/index.js"));
const WalletButton = ({ size = "sm" }) => {
    const { details: { mainAddress }, } = useWalletDetails();
    if (Boolean(mainAddress)) {
        return _jsx(LazyWalletDetailsPopover, { address: mainAddress, size: size });
    }
    return _jsx(ConnectWalletButton, { className: "ml-auto mr-auto lg:ml-0 lg:mr-0" });
};
export default WalletButton;
//# sourceMappingURL=WalletButton.js.map